import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: string): string {
    if (displayFormat === 'input') {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
    } else {
      return date.toDateString();
    }
  }

  override getYear(date: string | Date): number {
    if (typeof date === 'string') {
      const dateParts = date.split('-');

      const year = parseInt(dateParts[2], 10);

      return year;
    } else {
      return date.getFullYear();
    }
  }

  override getMonth(date: string | Date): number {
    if (typeof date === 'string') {
      const dateParts = date.split('-');

      const month = parseInt(dateParts[1], 10) - 1;

      return month;
    } else {
      return date.getMonth();
    }
  }

  override getDate(date: string | Date): number {
    if (typeof date === 'string') {
      const dateParts = date.split('-');
      const day = parseInt(dateParts[0], 10);
      return day;
    } else {
      return date.getDate();
    }
  }

  override parse(value: string | Date): Date | null {
    if (typeof value === 'string') {
      const dateParts = value.split('-');
      if (dateParts.length === 3) {
        const year = parseInt(dateParts[2], 10);
        const month = parseInt(dateParts[1], 10) - 1;
        const day = parseInt(dateParts[0], 10);
        return new Date(year, month, day);
      }
    }

    return super.parse(value);
  }
}
